import { useEffect, useState } from 'react';
import gsap from 'gsap';

export const Counter = ({ to, suffix = '', start = true, duration = 1.8, className = '' }) => {
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!start) { setV(0); return; }
    const o = { v: 0 };
    const tw = gsap.to(o, { v: to, duration, ease: 'power3.out', onUpdate: () => setV(Math.round(o.v)) });
    return () => tw.kill();
  }, [start, to, duration]);
  return <span className={className}>{v}{suffix}</span>;
};
